import script from "./NavbarHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./NavbarHeader.vue?vue&type=script&setup=true&lang=js"

import "./NavbarHeader.vue?vue&type=style&index=0&id=81ebd05a&lang=scss"

const __exports__ = script;

export default __exports__